/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Head from 'next/head';
import Header24 from '@/components/organisms/Header24';
import Footer24 from '@/components/organisms/Footer24';
import Styles from './EnergiaSolar.css';
import FaqLPs25 from '@/components/molecules/FaqLPs25';
import EnergiaSolarBlog from '@/components/organisms/EnergiaSolarBlog';
import EnergiaSolarBanner from '@/components/organisms/EnergiaSolarBanner';
import EnergiaSolarEconomia from '@/components/organisms/EnergiaSolarEconomia';
import EnergiaSolarPassoAPasso from '@/components/organisms/EnergiaSolarPassoAPasso';
import EnergiaSolarQualidade from '@/components/organisms/EnergiaSolarQualidade';
// import EnergiaSolarParceiros from '@/components/organisms/EnergiaSolarParceiros';
// import EnergiaSolarHeroMesAmbiente from '@/components/molecules/EnergiaSolarHeroMesAmbiente';
import {
  SimuladorSolarFormLanding,
  SimuladorSolarModalTerms,
} from '../../../modules/simulador-energia-solar';
import EnergiaSolarVantagens from '../../organisms/EnergiaSolarVantagens';

function EnergiaSolar() {
  const faqTitle = 'Saiba mais sobre energia solar';
  const imgpng = 'assets/energia-solar/img-perguntas.png';
  const imgwebp = 'assets/energia-solar/img-perguntas.webp';
  const imgpngdesk = 'assets/energia-solar/img-perguntas-desk.png';
  const imgwebpdesk = 'assets/energia-solar/img-perguntas-desk.webp';
  const imgalt =
    'Casal feliz e sorridente está em frente à sua casa moderna, que possui um painel solar no telhado.';
  const linkMostrarTodasPerguntas = 'energia-solar-fotovoltaica-perguntas-frequentes.html';
  const faqs = [
    {
      pergunta: 'Como funciona a Energia Solar?',
      resposta: `As placas solares captam os raios de sol e os transformam em energia elétrica por meio de um equipamento chamado inversor. A energia gerada é enviada para a rede elétrica e você passa a ter créditos de energia em sua conta. Caso gere mais do que consumiu, irá acumular créditos, caso consuma mais energia, irá receber uma conta de luz com a diferença entre o que foi gerado e consumido.`,
      startOpen: true,
    },
    {
      pergunta: 'Por que adquirir um sistema fotovoltaico?',
      resposta: `A energia solar é uma fonte de energia limpa e renovável, que traz um impacto positivo para o planeta e para sua comunidade. Além disso, valoriza o imóvel em que foi instalada e a melhor parte é que pode não custar nada mais do que o seu orçamento permite. É possível substituir a sua conta de luz pela parcela do painel solar, sendo um investimento de longo prazo, com mais de 20 anos de garantia dos painéis.`,
    },
    {
      pergunta: 'Quais os benefícios de adquirir um sistema fotovoltaico?',
      resposta: `Você irá gerar energia com um baixo impacto para o meio ambiente, além disso você troca o gasto em energia por um investimento em seu imóvel e o valoriza.`,
    },
    {
      pergunta: 'Onde consigo instalar o meu sistema fotovoltaico?',
      resposta: `É possível instalar o sistema fotovoltaico em telhados com incidência solar, além disso, a depender do caso, a instalação também pode ser feita no solo.`,
    },
    {
      pergunta: 'Como funciona o crédito na conta de luz?',
      resposta: `Toda a energia que gerada pela sua placa solar será enviada de volta para rede, gerando assim, créditos de consumo em sua conta de luz válidos por até 60 meses. Caso a geração de energia seja maior do que o consumido, mensalmente você pagará apenas a taxa de disponibilidade da concessionaria. Caso o consumo seja maior do que a geração, será paga a diferença entre eles para a empresa de energia.`,
    },
    {
      pergunta: 'Se eu instalar um sistema fotovoltaico, irei pagar conta de luz?',
      resposta: `Caso você gere mais energia do que consome, você pagará mensalmente a tarifa básica da concessionária de energia elétrica da sua região. Caso consuma mais energia do que gerou, terá de pagar o excedente. Porém, ao realizar o seu projeto, será considerado o seu consumo médio de energia e é provável que você só consuma mais energia do que o gerado caso haja algum consumo fora dos padrões (exemplo: instalação de um novo ar-condicionado, aquecedor na piscina).`,
    },
  ];
  return (
    <>
      <Head>
        <title>Financiamento de Energia Solar| Santander Financiamentos</title>
        <meta
          name="Description"
          content="Economize até 95% na conta de luz. Santander Financiamentos oferece crédito especial para você instalar sua placa solar com segurança."
        />
        <meta name="robots" content="index,follow" />
        <meta
          name="keywords"
          content="energia solar vantagens e desvantagens, energia fotovoltaica, sol como energia, gerador de energia solar, bateria energia solar, financiamento energia solar, quanto custa placa de energia solar, quanto custa placa solar, placa solar"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/energia-solar-fotovoltaica.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta
          property="og:title"
          content="Financiamento de Energia Solar| Santander Financiamentos"
        />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/energia-solar-fotovoltaica.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Economize até 95% na conta de luz. Santander Financiamentos oferece crédito especial para você instalar sua placa solar com segurança."
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/energia-solar/hero/banner-800.webp"
        />
        <meta
          property="og:image:alt"
          content="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta
          name="twitter:title"
          content="Financiamento de Energia Solar| Santander Financiamentos"
        />
        <meta
          name="twitter:description"
          content="Economize até 95% na conta de luz. Santander Financiamentos oferece crédito especial para você instalar sua placa solar com segurança."
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/energia-solar-fotovoltaica.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/energia-solar/hero/banner-800.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Casa térrea com painéis solares financiados com a Santander Financiamento, trazendo economia na conta de luz"
        />
        <meta property="twitter:image:type" content="image/png" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Header24 isHome24 showSearch={false} hideAreaCliente={true} />

      <EnergiaSolarBanner />
      <EnergiaSolarVantagens />
      <SimuladorSolarFormLanding />
      {/* <EnergiaSolarHeroMesAmbiente /> */}
      <EnergiaSolarPassoAPasso />
      <EnergiaSolarEconomia />
      <EnergiaSolarQualidade />
      {/* <EnergiaSolarParceiros /> */}

      <FaqLPs25
        imgpng={imgpng}
        imgwebp={imgwebp}
        imgpngdesk={imgpngdesk}
        imgwebpdesk={imgwebpdesk}
        imgalt={imgalt}
        faqtitle={faqTitle}
        faqs={faqs}
        linkMostrarTodasPerguntas={linkMostrarTodasPerguntas}
      />
      <EnergiaSolarBlog />
      <Footer24 />

      <SimuladorSolarModalTerms />

      <style jsx>{Styles}</style>
    </>
  );
}

export default EnergiaSolar;
